// src/pages/TwoFactorRequired.jsx
// Shown after sign-in to anyone without two-factor authentication, in
// place of the portal. They set it up here (or sign out); the portal opens
// once it's done and their recovery codes are saved. The server enforces
// the same rule, so the portal's data can't be reached without it.
import TwoFactorSetup from '../components/TwoFactorSetup';
import AuthShell, { A } from '../components/AuthShell';
import { useAuth } from '../hooks/useAuth';

export default function TwoFactorRequired({ onEnrolling, onDone }) {
  const { user, logout } = useAuth();

  return (
    <AuthShell brand={false} wide>
      <h1 style={S.title}>Set up two-factor authentication</h1>
      <p style={S.lead}>
        Two-factor authentication is <strong>required</strong> for everyone who uses the Fax Portal.
        Besides your {user?.providerData?.[0]?.providerId === 'google.com' ? 'Google sign-in' : 'password'}, you'll
        enter a 6-digit code from an app on your phone, so your faxes stay safe even if someone learns your password.
        It takes about two minutes.
      </p>
      <div style={S.youNeed}>
        <strong>You'll need:</strong> your phone with <strong>Google Authenticator</strong> or <strong>Microsoft Authenticator</strong> (free
        from the App Store or Google Play).
      </div>

      <TwoFactorSetup onEnrolling={onEnrolling} onDone={onDone} startLabel="Set up now" />

      <div style={S.footerRow}>
        <span style={S.signedInAs}>Signed in as {user?.email}</span>
        <button onClick={logout} style={S.link} className="auth-link">Sign out</button>
      </div>
    </AuthShell>
  );
}


const S = {  // 3.40.0: the page and card come from AuthShell; the rest follows its look (A)
  title: { ...A.title, margin: '0 0 10px' },
  lead: { ...A.text },
  youNeed: { margin: '0 0 18px', padding: '11px 14px', borderRadius: 12, background: 'linear-gradient(135deg, #f3f9ff, #e3f2fd)', border: '1px solid #bbdefb', color: '#0d47a1', fontSize: 13, lineHeight: 1.55 },
  footerRow: A.footerRow,
  signedInAs: A.signedInAs,
  link: A.link,
};
